import { eur } from "@/lib/format";

export const COLORS = {
  income: "#00FFA3",
  expense: "#FF3366",
  forecast: "#3388FF",
  balance: "#FFFFFF",
  grid: "#1f1f1f",
  axis: "#A1A1AA",
};

export const CATEGORY_COLORS = [
  "#00FFA3", "#3388FF", "#FF3366", "#F5C542", "#B27BFF",
  "#00D4D4", "#FF8A3D", "#7CFF6B", "#FF5FA2", "#5C9DFF",
  "#E0E0E0", "#8A8A8A",
];

export const axisProps = {
  stroke: COLORS.axis,
  tick: { fill: COLORS.axis, fontSize: 11 },
  tickLine: false,
  axisLine: false,
};

export function ChartTooltip({ active, payload, label, valueFormatter = eur }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded-md px-3 py-2 shadow-lg">
      {label && <p className="text-xs text-muted-foreground mb-1.5">{label}</p>}
      <div className="space-y-1">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center justify-between gap-4 text-xs">
            <span className="flex items-center gap-1.5">
              <span className="w-2 h-2 rounded-sm" style={{ background: p.color || p.fill }} />
              <span className="text-muted-foreground capitalize">{p.name}</span>
            </span>
            <span className="tabular-nums font-medium">{valueFormatter(p.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
